"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5162],{

/***/ 52036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CommitButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45388);
/* harmony import */ var hooks_useSwitchNetworkLoading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95579);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70024);
/* harmony import */ var hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56797);
/* harmony import */ var _NetworkModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46580);
/* harmony import */ var _Trans__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4369);










var wrongNetworkProps = {
    variant: "primary",
    disabled: false,
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Trans__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: "Wrong Network"
    })
};
var CommitButton = function(props) {
    var isWrongNetwork = (0,hooks_useActiveChainId__WEBPACK_IMPORTED_MODULE_2__/* .useActiveChainId */ .g)().isWrongNetwork;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,hooks_useSwitchNetworkLoading__WEBPACK_IMPORTED_MODULE_1__/* .useSwitchNetworkLoading */ .c)(), 1), switchNetworkLoading = ref[0];
    var setHideWrongNetwork = (0,jotai__WEBPACK_IMPORTED_MODULE_6__/* .useSetAtom */ .b9)(_NetworkModal__WEBPACK_IMPORTED_MODULE_3__/* .hideWrongNetworkModalAtom */ .v);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        onClick: function(e) {
            if (isWrongNetwork) {
                setHideWrongNetwork(false);
            } else {
                var ref;
                (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props, e);
            }
        }
    }), switchNetworkLoading && {
        disabled: true
    }, isWrongNetwork && wrongNetworkProps));
};


/***/ }),

/***/ 53258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CurrencyInputPanel; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Copy.tsx
var Copy = __webpack_require__(84298);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(62255);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(6538);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(39917);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var src = __webpack_require__(68486);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(2629);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var hooks = __webpack_require__(5460);
// EXTERNAL MODULE: ./src/components/SearchModal/CurrencySearchModal.tsx + 10 modules
var CurrencySearchModal = __webpack_require__(28847);
// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(19259);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/components/CurrencyInputPanel/NumericalInput.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  width: 0;\n  position: relative;\n  font-weight: 500;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: transparent;\n  font-size: 16px;\n  text-align: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  [type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-dcdc9d17-0"
})(_templateObject(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.text : theme.colors.text;
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "left";
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var Input = /*#__PURE__*/ (0,react.memo)(function InnerInput(_param) {
    var value = _param.value, onUserInput = _param.onUserInput, placeholder = _param.placeholder, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onUserInput",
        "placeholder"
    ]);
    var enforcer = function(nextUserInput) {
        if (nextUserInput === "" || inputRegex.test((0,utils/* escapeRegExp */.hr)(nextUserInput))) {
            onUserInput(nextUserInput);
        }
    };
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        value: value,
        onChange: function(event) {
            // replace commas with periods, because we exclusively uses period as the decimal separator
            enforcer(event.target.value.replace(/,/g, "."));
        },
        // universal input options
        inputMode: "decimal",
        title: t("Token Amount"),
        autoComplete: "off",
        autoCorrect: "off",
        // text-specific options
        type: "text",
        pattern: "^[0-9]*[.,]?[0-9]*$",
        placeholder: placeholder || "0.0",
        minLength: 1,
        maxLength: 40,
        spellCheck: "false"
    }));
});
/* harmony default export */ var NumericalInput = ((/* unused pure expression or super */ null && (Input)));

;// CONCATENATED MODULE: ./src/components/CurrencyInputPanel/index.tsx


function CurrencyInputPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  width: 40%;\n"
    ]);
    CurrencyInputPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 8px;\n      height: auto;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom:none!important;\n  margin-bottom: 8px;\n  padding:0px !important;\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 0.75rem 1rem 0 1rem;\n  justify-content:space-between;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  color: ",
        ";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  /* padding: 0.75rem 1rem 0 0rem; */\n  justify-content:flex-end;\n  width: 60%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  padding: 10px 10px 10px 16px;\n  border-radius:12px;\n  flex-flow: column nowrap;\n  position: relative;\n  background-color: ",
        ";\n  z-index: 1;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction:row;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset: 0;\n  opacity: 0.6;\n  background-color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill:#6C5DD3!important;\n  width: 12px;\n  height: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  position: absolute;\n  padding: 8px;\n  top: -35px;\n  right: -15px;\n  text-align: center;\n  background-color: #fff;\n  color: #000;\n  border-radius: 16px;\n  width: 100px;\n  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.1);\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border:none;\n  color:",
        ";\n  font-weight:bold;\n  text-transform:uppercase;\n  background:transparent;\n  font-size:16px;\n  cursor: pointer;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}













var InputRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f32f5d0-0"
})(CurrencyInputPanel_templateObject());
var CurrencySelectButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    variant: "text",
    scale: "sm"
}).withConfig({
    componentId: "sc-f32f5d0-1"
})(_templateObject2(), function(param) {
    var zapStyle = param.zapStyle, theme = param.theme;
    return zapStyle && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
var LabelRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f32f5d0-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsLabelRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f32f5d0-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var InputPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f32f5d0-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f32f5d0-5"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var Overlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f32f5d0-6"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var CustomIconCopy = (0,styled_components_browser_esm/* default */.ZP)(Copy/* default */.Z).withConfig({
    componentId: "sc-f32f5d0-7"
})(_templateObject8());
var Tooltip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f32f5d0-8"
})(_templateObject9(), function(param) {
    var isTooltipDisplayed = param.isTooltipDisplayed;
    return isTooltipDisplayed ? "inline-block" : "none";
});
var CsButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-f32f5d0-9"
})(_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var ContainerIcon = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-f32f5d0-10"
})(_templateObject11());
var Relative = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f32f5d0-11"
})(_templateObject12());
function CurrencyInputPanel(param) {
    var value = param.value, onUserInput = param.onUserInput, onInputBlur = param.onInputBlur, onPercentInput = param.onPercentInput, onMax = param.onMax, _showQuickInputButton = param.showQuickInputButton, showQuickInputButton = _showQuickInputButton === void 0 ? false : _showQuickInputButton, showMaxButton = param.showMaxButton, label = param.label, onCurrencySelect = param.onCurrencySelect, currency = param.currency, _disableCurrencySelect = param.disableCurrencySelect, disableCurrencySelect = _disableCurrencySelect === void 0 ? false : _disableCurrencySelect, _hideBalance = param.hideBalance, hideBalance = _hideBalance === void 0 ? false : _hideBalance, zapStyle = param.zapStyle, beforeButton = param.beforeButton, _pair = param.pair, pair = _pair === void 0 ? null : _pair, otherCurrency = param.otherCurrency, id = param.id, showCommonBases = param.showCommonBases, commonBasesType = param.commonBasesType, disabled = param.disabled, error = param.error, showBUSD = param.showBUSD;
    var displayTooltip = function displayTooltip() {
        setIsTooltipDisplayed(true);
        setTimeout(function() {
            setIsTooltipDisplayed(false);
        }, 2000);
    };
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var selectedCurrencyBalance = (0,hooks/* useCurrencyBalance */._h)(account !== null && account !== void 0 ? account : undefined, currency !== null && currency !== void 0 ? currency : undefined);
    var t = (0,src/* useTranslation */.$G)().t;
    var token = pair ? pair.liquidityToken : (currency === null || currency === void 0 ? void 0 : currency.isToken) ? currency : null;
    var tokenAddress = token ? (0,utils/* isAddress */.UJ)(token.address) : null;
    var translatedLabel = label || t("Input");
    var amountInDollar = (0,useBUSDPrice/* useBUSDCurrencyAmount */.vB)(showBUSD ? currency : undefined, Number.isFinite(+value) ? +value : undefined);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySearchModal/* default */.Z, {
        onCurrencySelect: onCurrencySelect,
        selectedCurrency: currency,
        otherSelectedCurrency: otherCurrency,
        showCommonBases: showCommonBases,
        commonBasesType: commonBasesType
    })), 1), onPresentCurrencyModal = ref[0];
    var ref1 = (0,react.useState)(false), isTooltipDisplayed = ref1[0], setIsTooltipDisplayed = ref1[1];
    var handleCopy = function() {
        if (navigator.clipboard && navigator.permissions) {
            navigator.clipboard.writeText(tokenAddress).then(function() {
                return displayTooltip();
            });
        } else if (document.queryCommandSupported("copy")) {
            var ele = document.createElement("textarea");
            ele.value = tokenAddress;
            document.body.appendChild(ele);
            ele.select();
            document.execCommand("copy");
            document.body.removeChild(ele);
            displayTooltip();
        }
    };
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        position: "relative",
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencySelectButton, {
                        zapStyle: zapStyle,
                        className: "open-currency-select-button",
                        selected: !!currency,
                        onClick: function() {
                            if (!disableCurrencySelect) {
                                onPresentCurrencyModal();
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            justifyContent: "space-between",
                            children: [
                                pair ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* DoubleCurrencyLogo */.ge, {
                                    currency0: pair.token0,
                                    currency1: pair.token1,
                                    size: 16,
                                    margin: true
                                }) : currency ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                    currency: currency,
                                    size: "24px",
                                    style: {
                                        marginRight: "8px"
                                    }
                                }) : null,
                                pair ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    id: "pair",
                                    bold: true,
                                    children: [
                                        pair === null || pair === void 0 ? void 0 : pair.token0.symbol,
                                        ":",
                                        pair === null || pair === void 0 ? void 0 : pair.token1.symbol
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    id: "pair",
                                    bold: true,
                                    children: (currency && currency.symbol && currency.symbol.length > 20 ? "".concat(currency.symbol.slice(0, 4), "...").concat(currency.symbol.slice(currency.symbol.length - 5, currency.symbol.length)) : currency === null || currency === void 0 ? void 0 : currency.symbol) || t("Select a currency")
                                }),
                                !disableCurrencySelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "space-between",
                        children: account && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            onClick: !disabled && onMax,
                            color: "text",
                            fontSize: "14px",
                            style: {
                                display: "inline",
                                cursor: "pointer"
                            },
                            children: !hideBalance && !!currency ? t("Balance: %balance%", {
                                balance: (ref2 = selectedCurrencyBalance === null || selectedCurrencyBalance === void 0 ? void 0 : selectedCurrencyBalance.toSignificant(6)) !== null && ref2 !== void 0 ? ref2 : t("Loading")
                            }) : " -"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputPanel, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                        as: "label",
                        zapStyle: zapStyle,
                        error: error,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CsLabelRow, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                    error: error,
                                    disabled: disabled,
                                    className: "token-amount-input",
                                    value: value,
                                    onBlur: onInputBlur,
                                    onUserInput: function(val) {
                                        onUserInput(val);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputRow, {
                                selected: disableCurrencySelect,
                                children: [
                                    !!currency && showBUSD && Number.isFinite(amountInDollar) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        fontSize: "12px",
                                        color: "textSubtle",
                                        mr: "12px",
                                        children: [
                                            "~",
                                            (0,formatBalance/* formatNumber */.uf)(amountInDollar),
                                            " USD"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        alignItems: "right",
                                        justifyContent: "flex-end",
                                        width: "100%",
                                        children: account && currency && (selectedCurrencyBalance === null || selectedCurrencyBalance === void 0 ? void 0 : selectedCurrencyBalance.greaterThan(0)) && !disabled && label !== "To" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                            children: showMaxButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButton, {
                                                onClick: onMax,
                                                children: t("Max")
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 94071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pM": function() { return /* binding */ ConfirmationModalContent; },
  "ht": function() { return /* binding */ TransactionErrorContent; },
  "rD": function() { return /* binding */ TransactionSubmittedContent; },
  "ZP": function() { return /* binding */ components_TransactionConfirmationModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx + 2 modules
var Spinner = __webpack_require__(53760);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(31282);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(199);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(6538);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ErrorBig.tsx
var ErrorBig = __webpack_require__(33417);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(86876);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var src = __webpack_require__(68486);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(73938);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 11 modules
var tokens_src = __webpack_require__(23768);
// EXTERNAL MODULE: ./src/components/Layout/Column.tsx
var Column = __webpack_require__(941);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/BinanceChain.tsx
var BinanceChain = __webpack_require__(82890);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/CoinbaseWallet.tsx
var CoinbaseWallet = __webpack_require__(84250);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Opera.tsx
var Opera = __webpack_require__(81206);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TokenPocket.tsx
var TokenPocket = __webpack_require__(21500);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/TrustWallet.tsx
var TrustWallet = __webpack_require__(77446);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Metamask.tsx
var Metamask = __webpack_require__(97263);
// EXTERNAL MODULE: ./src/components/Logo/Logo.tsx
var Logo = __webpack_require__(52175);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./src/utils/wallet.ts
var wallet = __webpack_require__(36514);
;// CONCATENATED MODULE: ./src/components/AddToWallet/AddToWalletButton.tsx









var AddToWalletTextOptions;
(function(AddToWalletTextOptions) {
    AddToWalletTextOptions[AddToWalletTextOptions["NO_TEXT"] = 0] = "NO_TEXT";
    AddToWalletTextOptions[AddToWalletTextOptions["TEXT"] = 1] = "TEXT";
    AddToWalletTextOptions[AddToWalletTextOptions["TEXT_WITH_ASSET"] = 2] = "TEXT_WITH_ASSET";
})(AddToWalletTextOptions || (AddToWalletTextOptions = {}));
var Icons = {
    // TODO: Brave
    Binance: BinanceChain/* default */.Z,
    "Coinbase Wallet": CoinbaseWallet/* default */.Z,
    Opera: Opera/* default */.Z,
    TokenPocket: TokenPocket/* default */.Z,
    "Trust Wallet": TrustWallet/* default */.Z,
    MetaMask: Metamask/* default */.Z
};
var getWalletText = function(textOptions, tokenSymbol, t) {
    return textOptions !== AddToWalletTextOptions.NO_TEXT && (textOptions === AddToWalletTextOptions.TEXT ? t("Add to Wallet") : t("Add %asset% to Wallet", {
        asset: tokenSymbol
    }));
};
var getWalletIcon = function(marginTextBetweenLogo, name) {
    var ref, ref1, ref2, ref3;
    var iconProps = (0,_object_spread/* default */.Z)({
        width: "16px"
    }, marginTextBetweenLogo && {
        ml: marginTextBetweenLogo
    });
    if (name && Icons[name]) {
        var Icon = Icons[name];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, (0,_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isTrust) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustWallet/* default */.Z, (0,_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref1 = window.ethereum) === null || ref1 === void 0 ? void 0 : ref1.isCoinbaseWallet) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinbaseWallet/* default */.Z, (0,_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref2 = window.ethereum) === null || ref2 === void 0 ? void 0 : ref2.isTokenPocket) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPocket/* default */.Z, (0,_object_spread/* default */.Z)({}, iconProps));
    }
    if (window === null || window === void 0 ? void 0 : (ref3 = window.ethereum) === null || ref3 === void 0 ? void 0 : ref3.isMetaMask) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Metamask/* default */.Z, (0,_object_spread/* default */.Z)({}, iconProps));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Metamask/* default */.Z, (0,_object_spread/* default */.Z)({}, iconProps));
};
var AddToWalletButton = function(_param) {
    var tokenAddress = _param.tokenAddress, tokenSymbol = _param.tokenSymbol, tokenDecimals = _param.tokenDecimals, tokenLogo = _param.tokenLogo, _textOptions = _param.textOptions, textOptions = _textOptions === void 0 ? AddToWalletTextOptions.NO_TEXT : _textOptions, _marginTextBetweenLogo = _param.marginTextBetweenLogo, marginTextBetweenLogo = _marginTextBetweenLogo === void 0 ? "0px" : _marginTextBetweenLogo, props = (0,_object_without_properties/* default */.Z)(_param, [
        "tokenAddress",
        "tokenSymbol",
        "tokenDecimals",
        "tokenLogo",
        "textOptions",
        "marginTextBetweenLogo"
    ]);
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,dist/* useAccount */.mA)(), connector = ref.connector, isConnected = ref.isConnected;
    var isCanRegisterToken = (0,wallet/* canRegisterToken */.U)();
    if (connector && connector.name === "Binance") return null;
    if (!(connector && connector.watchAsset && isConnected)) return null;
    if (!isCanRegisterToken) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onClick: function() {
            var ref;
            var image = tokenLogo ? Logo/* BAD_SRCS */.X[tokenLogo] ? undefined : tokenLogo : undefined;
            (ref = connector.watchAsset) === null || ref === void 0 ? void 0 : ref.call(connector, {
                address: tokenAddress,
                symbol: tokenSymbol,
                image: image,
                // @ts-ignore
                decimals: tokenDecimals
            });
        },
        children: [
            getWalletText(textOptions, tokenSymbol, t),
            getWalletIcon(marginTextBetweenLogo, connector === null || connector === void 0 ? void 0 : connector.name)
        ]
    }));
};
/* harmony default export */ var AddToWallet_AddToWalletButton = (AddToWalletButton);

;// CONCATENATED MODULE: ./src/components/TransactionConfirmationModal/index.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width:500px;\n  @media(max-width:600px){\n     overflow-x:hidden;\n     overflow-y:auto;\n     margin-top:20px;\n  }\n\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background:transparent !important;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7f694d23-0"
})(_templateObject());
var Section = (0,styled_components_browser_esm/* default */.ZP)(Column/* AutoColumn */.Tz).withConfig({
    componentId: "sc-7f694d23-1"
})(_templateObject1());
var ConfirmedIcon = (0,styled_components_browser_esm/* default */.ZP)(Column/* ColumnCenter */.lg).withConfig({
    componentId: "sc-7f694d23-2"
})(_templateObject2());
var CustomAutoColumn = (0,styled_components_browser_esm/* default */.ZP)(Column/* AutoColumn */.Tz).withConfig({
    componentId: "sc-7f694d23-3"
})(_templateObject3());
function ConfirmationPendingContent(param) {
    var pendingText = param.pendingText;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmedIcon, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                gap: "12px",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "20px",
                        children: t("Waiting For Confirmation")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                        gap: "12px",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            small: true,
                            textAlign: "center",
                            children: pendingText
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "center",
                        children: t("Confirm this transaction in your wallet")
                    })
                ]
            })
        ]
    });
}
function TransactionSubmittedContent(param) {
    var onDismiss = param.onDismiss, chainId = param.chainId, hash = param.hash, currencyToAdd = param.currencyToAdd;
    var t = (0,src/* useTranslation */.$G)().t;
    var token = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyToAdd, chainId);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmedIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
                        strokeWidth: 0.5,
                        width: "90px",
                        color: "text"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    gap: "12px",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "20px",
                            children: t("Transaction Submitted")
                        }),
                        chainId && hash && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            external: true,
                            small: true,
                            href: (0,utils/* getBlockExploreLink */.C)(hash, "transaction", chainId),
                            children: t("View on %site%", {
                                site: (0,utils/* getBlockExploreName */.X0)(chainId)
                            })
                        }),
                        currencyToAdd && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToWallet_AddToWalletButton, {
                            variant: "secondary",
                            mt: "12px",
                            width: "100%",
                            marginTextBetweenLogo: "6px",
                            textOptions: AddToWalletTextOptions.TEXT_WITH_ASSET,
                            tokenAddress: token.address,
                            tokenSymbol: currencyToAdd.symbol,
                            tokenDecimals: token.decimals,
                            tokenLogo: (0,_instanceof/* default */.Z)(token, tokens_src/* WrappedTokenInfo */.DT) ? token.logoURI : undefined
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            width: "100%",
                            onClick: onDismiss,
                            mt: "15px",
                            children: t("Close")
                        })
                    ]
                })
            ]
        })
    });
}
function ConfirmationModalContent(param) {
    var bottomContent = param.bottomContent, topContent = param.topContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: topContent()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: bottomContent()
            })
        ]
    });
}
function TransactionErrorContent(param) {
    var message = param.message, onDismiss = param.onDismiss;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomAutoColumn, {
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBig/* default */.Z, {
                        color: "blue",
                        width: "64px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "#000",
                        style: {
                            textAlign: "center",
                            width: "85%",
                            wordBreak: "break-word"
                        },
                        children: message
                    })
                ]
            }),
            onDismiss ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "center",
                pt: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    onClick: onDismiss,
                    children: t("Dismiss")
                })
            }) : null
        ]
    });
}
var TransactionConfirmationModal = function(_param) {
    var title = _param.title, onDismiss = _param.onDismiss, customOnDismiss = _param.customOnDismiss, attemptingTxn = _param.attemptingTxn, hash = _param.hash, pendingText = _param.pendingText, content = _param.content, currencyToAdd = _param.currencyToAdd, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "onDismiss",
        "customOnDismiss",
        "attemptingTxn",
        "hash",
        "pendingText",
        "content",
        "currencyToAdd"
    ]);
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var handleDismiss = (0,react.useCallback)(function() {
        if (customOnDismiss) {
            customOnDismiss();
        }
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, [
        customOnDismiss,
        onDismiss
    ]);
    if (!chainId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        headerBackground: "gradientCardHeader"
    }, props), {
        onDismiss: handleDismiss,
        children: attemptingTxn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationPendingContent, {
            pendingText: pendingText
        }) : hash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionSubmittedContent, {
            chainId: chainId,
            hash: hash,
            onDismiss: handleDismiss,
            currencyToAdd: currencyToAdd
        }) : content()
    }));
};
/* harmony default export */ var components_TransactionConfirmationModal = (TransactionConfirmationModal);


/***/ }),

/***/ 36585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UK": function() { return /* binding */ ApprovalState; },
  "qL": function() { return /* binding */ useApproveCallback; },
  "re": function() { return /* binding */ useApproveCallbackFromTrade; }
});

// UNUSED EXPORTS: useApproveCallbackFromInputCurrencyAmount

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var src = __webpack_require__(68486);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(61135);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var wagmi_src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(56974);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(70486);
// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(15103);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var hooks = __webpack_require__(56906);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(17937);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var swap_sdk_src = __webpack_require__(1505);
// EXTERNAL MODULE: ./node_modules/@gelatonetwork/limit-orders-lib/dist/index.js
var dist = __webpack_require__(55855);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var hooks_useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/hooks/useProviderOrSigner.ts
var hooks_useProviderOrSigner = __webpack_require__(99648);
;// CONCATENATED MODULE: ./src/hooks/limitOrders/useGelatoLimitOrdersLib.ts






var useGelatoLimitOrdersLib_useGelatoLimitOrdersLib = function() {
    var chainId = useActiveWeb3React().chainId;
    var providerOrSigner = useProviderOrSigner();
    return useMemo(function() {
        if (!chainId || !providerOrSigner) {
            console.error("Could not instantiate GelatoLimitOrders: missing chainId or library");
            return undefined;
        }
        if (chainId !== ChainId.BSC) return undefined;
        try {
            return new GelatoLimitOrders(chainId, providerOrSigner, GELATO_HANDLER, false);
        } catch (error) {
            console.error("Could not instantiate GelatoLimitOrders: ".concat(error.message));
            return undefined;
        }
    }, [
        chainId,
        providerOrSigner
    ]);
};
/* harmony default export */ var limitOrders_useGelatoLimitOrdersLib = ((/* unused pure expression or super */ null && (useGelatoLimitOrdersLib_useGelatoLimitOrdersLib)));

// EXTERNAL MODULE: ./src/hooks/useCallWithMarketGasPrice.ts
var useCallWithMarketGasPrice = __webpack_require__(31063);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 13 modules
var useContract = __webpack_require__(91298);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var multicall_hooks = __webpack_require__(410);
;// CONCATENATED MODULE: ./src/hooks/useTokenAllowance.ts




function useTokenAllowance(token, owner, spender) {
    var contract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address, false);
    var inputs = (0,react.useMemo)(function() {
        return [
            owner,
            spender
        ];
    }, [
        owner,
        spender
    ]);
    var allowance = (0,multicall_hooks/* useSingleCallResult */.Wk)(contract, "allowance", inputs).result;
    return (0,react.useMemo)(function() {
        return token && allowance ? swap_sdk_src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(token, allowance.toString()) : undefined;
    }, [
        token,
        allowance
    ]);
}
/* harmony default export */ var hooks_useTokenAllowance = (useTokenAllowance);

;// CONCATENATED MODULE: ./src/hooks/useApproveCallback.ts

















var ApprovalState;
(function(ApprovalState) {
    ApprovalState[ApprovalState["UNKNOWN"] = 0] = "UNKNOWN";
    ApprovalState[ApprovalState["NOT_APPROVED"] = 1] = "NOT_APPROVED";
    ApprovalState[ApprovalState["PENDING"] = 2] = "PENDING";
    ApprovalState[ApprovalState["APPROVED"] = 3] = "APPROVED";
})(ApprovalState || (ApprovalState = {}));
// returns a variable indicating the state of the approval and a function which approves if necessary or early returns
function useApproveCallback(amountToApprove, spender) {
    var ref;
    var account = (0,wagmi_src/* useWeb3React */.Ge)().account;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var t = (0,src/* useTranslation */.$G)().t;
    var toastError = (0,useToast/* useToast */.p)().toastError;
    var token = (amountToApprove === null || amountToApprove === void 0 ? void 0 : (ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isToken) ? amountToApprove.currency : undefined;
    var currentAllowance = hooks_useTokenAllowance(token, account !== null && account !== void 0 ? account : undefined, spender);
    var pendingApproval = (0,hooks/* useHasPendingApproval */.wB)(token === null || token === void 0 ? void 0 : token.address, spender);
    // check the current approval status
    var approvalState = (0,react.useMemo)(function() {
        var ref;
        if (!amountToApprove || !spender) return ApprovalState.UNKNOWN;
        if ((ref = amountToApprove.currency) === null || ref === void 0 ? void 0 : ref.isNative) return ApprovalState.APPROVED;
        // we might not have enough data to know whether or not we need to approve
        if (!currentAllowance) return ApprovalState.UNKNOWN;
        // amountToApprove will be defined if currentAllowance is
        return currentAllowance.lessThan(amountToApprove) ? pendingApproval ? ApprovalState.PENDING : ApprovalState.NOT_APPROVED : ApprovalState.APPROVED;
    }, [
        amountToApprove,
        currentAllowance,
        pendingApproval,
        spender
    ]);
    var tokenContract = (0,useContract/* useTokenContract */.Ib)(token === null || token === void 0 ? void 0 : token.address);
    var addTransaction = (0,hooks/* useTransactionAdder */.h7)();
    var approve = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var useExact, estimatedGas;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (approvalState !== ApprovalState.NOT_APPROVED) {
                        toastError(t("Error"), t("Approve was called unnecessarily"));
                        console.error("approve was called unnecessarily");
                        return [
                            2
                        ];
                    }
                    if (!token) {
                        toastError(t("Error"), t("No token"));
                        console.error("no token");
                        return [
                            2
                        ];
                    }
                    if (!tokenContract) {
                        toastError(t("Error"), t("Cannot find contract of the token %tokenAddress%", {
                            tokenAddress: token === null || token === void 0 ? void 0 : token.address
                        }));
                        console.error("tokenContract is null");
                        return [
                            2
                        ];
                    }
                    if (!amountToApprove) {
                        toastError(t("Error"), t("Missing amount to approve"));
                        console.error("missing amount to approve");
                        return [
                            2
                        ];
                    }
                    if (!spender) {
                        toastError(t("Error"), t("No spender"));
                        console.error("no spender");
                        return [
                            2
                        ];
                    }
                    useExact = false;
                    return [
                        4,
                        tokenContract.estimateGas.approve(spender, bignumbers/* MaxUint256 */.Bz).catch(function() {
                            // general fallback for tokens who restrict approval amounts
                            useExact = true;
                            return tokenContract.estimateGas.approve(spender, amountToApprove.quotient.toString());
                        })
                    ];
                case 1:
                    estimatedGas = _state.sent();
                    // eslint-disable-next-line consistent-return
                    return [
                        2,
                        callWithMarketGasPrice(tokenContract, "approve", [
                            spender,
                            useExact ? amountToApprove.quotient.toString() : bignumbers/* MaxUint256 */.Bz
                        ], {
                            gasLimit: (0,utils/* calculateGasMargin */.yC)(estimatedGas)
                        }).then(function(response) {
                            addTransaction(response, {
                                summary: "Approve ".concat(amountToApprove.currency.symbol),
                                translatableSummary: {
                                    text: "Approve %symbol%",
                                    data: {
                                        symbol: amountToApprove.currency.symbol
                                    }
                                },
                                approval: {
                                    tokenAddress: token.address,
                                    spender: spender
                                },
                                type: "approve"
                            });
                        }).catch(function(error) {
                            (0,sentry/* logError */.H)(error);
                            console.error("Failed to approve token", error);
                            if ((error === null || error === void 0 ? void 0 : error.code) !== 4001) {
                                toastError(t("Error"), "An unspecified error occurred. Please try again");
                            }
                            toastError(t("Error"), t("Please try again. Confirm the transaction and make sure you are paying enough gas!"));
                        })
                    ];
            }
        });
    }), [
        approvalState,
        token,
        tokenContract,
        amountToApprove,
        spender,
        addTransaction,
        callWithMarketGasPrice,
        t,
        toastError, 
    ]);
    return [
        approvalState,
        approve
    ];
}
// wraps useApproveCallback in the context of a swap
function useApproveCallbackFromTrade(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, chainId = arguments.length > 2 ? arguments[2] : void 0;
    var amountToApprove = (0,react.useMemo)(function() {
        return trade ? (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage)[actions/* Field.INPUT */.gN.INPUT] : undefined;
    }, [
        trade,
        allowedSlippage
    ]);
    return useApproveCallback(amountToApprove, exchange/* ROUTER_ADDRESS */.bR[chainId]);
}
// Wraps useApproveCallback in the context of a Gelato Limit Orders
function useApproveCallbackFromInputCurrencyAmount(currencyAmountIn) {
    var gelatoLibrary = useGelatoLimitOrdersLib();
    var _address;
    return useApproveCallback(currencyAmountIn, (_address = gelatoLibrary === null || gelatoLibrary === void 0 ? void 0 : gelatoLibrary.erc20OrderRouter.address) !== null && _address !== void 0 ? _address : undefined);
}


/***/ }),

/***/ 31063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useCallWithMarketGasPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92876);







function useCallWithMarketGasPrice() {
    /**
   * Perform a contract call with a gas price returned from useGasPrice
   * @param contract Used to perform the call
   * @param methodName The name of the method called
   * @param methodArgs An array of arguments to pass to the method
   * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
   * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
   */ var callWithMarketGasPrice = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(contract, methodName) {
            var methodArgs, overrides, contractMethod, tx, ref;
            var _arguments = arguments;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        methodArgs = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : [], overrides = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : null;
                        (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                            type: "Transaction",
                            message: "Call with market gas price",
                            data: {
                                contractAddress: contract.address,
                                methodName: methodName,
                                methodArgs: methodArgs,
                                overrides: overrides
                            }
                        });
                        contractMethod = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contract, methodName);
                        return [
                            4,
                            contractMethod.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(methodArgs).concat([
                                (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, overrides)
                            ]))
                        ];
                    case 1:
                        tx = _state.sent();
                        if (tx) {
                            ;
                            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .addBreadcrumb */ .n_)({
                                type: "Transaction",
                                message: "Transaction sent: ".concat(tx.hash),
                                data: {
                                    hash: tx.hash,
                                    from: tx.from,
                                    gasLimit: (ref = tx.gasLimit) === null || ref === void 0 ? void 0 : ref.toString(),
                                    nonce: tx.nonce
                                }
                            });
                        }
                        return [
                            2,
                            tx
                        ];
                }
            });
        });
        return function(contract, methodName) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        callWithMarketGasPrice: callWithMarketGasPrice
    };
}


/***/ }),

/***/ 25490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTransactionDeadline; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/multicall/hooks.ts
var hooks = __webpack_require__(410);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 13 modules
var useContract = __webpack_require__(91298);
;// CONCATENATED MODULE: ./src/hooks/useCurrentBlockTimestamp.ts


// gets the current timestamp from the blockchain
function useCurrentBlockTimestamp() {
    var ref, ref1;
    var multicall = (0,useContract/* useMulticallContract */.gq)();
    return (ref = (0,hooks/* useSingleCallResult */.Wk)(multicall, "getCurrentBlockTimestamp")) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
}

;// CONCATENATED MODULE: ./src/hooks/useTransactionDeadline.ts



// combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction
function useTransactionDeadline() {
    var ttl = (0,es/* useSelector */.v9)(function(state) {
        return state.user.userDeadline;
    });
    var blockTimestamp = useCurrentBlockTimestamp();
    return (0,react.useMemo)(function() {
        if (blockTimestamp && ttl) return blockTimestamp.add(ttl);
        return undefined;
    }, [
        blockTimestamp,
        ttl
    ]);
}


/***/ }),

/***/ 70486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; },
/* harmony export */   "Z": function() { return /* binding */ isUserRejected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92876);


var assignError = function(maybeError) {
    if (typeof maybeError === "string") {
        return new Error(maybeError);
    }
    if (typeof maybeError === "object") {
        var ref;
        var error = new Error((ref = maybeError === null || maybeError === void 0 ? void 0 : maybeError.message) !== null && ref !== void 0 ? ref : String(maybeError));
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.stack) {
            error.stack = maybeError.stack;
        }
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.code) {
            error.name = maybeError.code;
        }
        return error;
    }
    return maybeError;
};
var isUserRejected = function(err) {
    // provider user rejected error code
    return typeof err === "object" && "code" in err && err.code === 4001;
};
var ENABLED_LOG = false;
var logError = function(error) {
    if (ENABLED_LOG) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(error, Error)) {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb)(error);
        } else {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb)(assignError(error), error);
        }
    }
    console.error(error);
};


/***/ }),

/***/ 78809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ transactionErrorToUserReadableMessage; }
/* harmony export */ });
/**
 * This is hacking out the revert reason from the ethers provider thrown error however it can.
 * This object seems to be undocumented by ethers.
 * @param error an error from the ethers provider
 * @param t Translation function
 */ function transactionErrorToUserReadableMessage(error, t) {
    var reason;
    while(error){
        var ref, ref1;
        var _reason, ref2, ref3;
        reason = (ref3 = (ref2 = (_reason = error.reason) !== null && _reason !== void 0 ? _reason : (ref = error.data) === null || ref === void 0 ? void 0 : ref.message) !== null && ref2 !== void 0 ? ref2 : error.message) !== null && ref3 !== void 0 ? ref3 : reason;
        var _error;
        // eslint-disable-next-line no-param-reassign
        error = (_error = error.error) !== null && _error !== void 0 ? _error : (ref1 = error.data) === null || ref1 === void 0 ? void 0 : ref1.originalError;
    }
    if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("execution reverted: ")) === 0) reason = reason.substring("execution reverted: ".length);
    switch(reason){
        case "PancakeRouter: EXPIRED":
            return t("The transaction could not be sent because the deadline has passed. Please check that your transaction deadline is not too low.");
        case "PancakeRouter: INSUFFICIENT_OUTPUT_AMOUNT":
        case "PancakeRouter: EXCESSIVE_INPUT_AMOUNT":
        case "PancakeRouter: INSUFFICIENT_A_AMOUNT":
        case "PancakeRouter: INSUFFICIENT_B_AMOUNT":
            return t("This transaction will not succeed either due to price movement or fee on transfer. Try increasing your slippage tolerance.");
        case "TransferHelper: TRANSFER_FROM_FAILED":
            return t("The input token cannot be transferred. There may be an issue with the input token.");
        case "Cloud: TRANSFER_FAILED":
            return t("The output token cannot be transferred. There may be an issue with the output token.");
        default:
            if ((reason === null || reason === void 0 ? void 0 : reason.indexOf("undefined is not an object")) !== -1) {
                console.error(error, reason);
                return t("An error occurred when trying to execute this operation. You may need to increase your slippage tolerance. If that does not work, there may be an incompatibility with the token you are trading.");
            }
            return t("Unknown error%reason%. Try increasing your slippage tolerance.", {
                reason: reason ? ': "'.concat(reason, '"') : ""
            });
    }
}


/***/ }),

/***/ 36514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ registerToken; },
/* harmony export */   "U": function() { return /* binding */ canRegisterToken; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20414);
/* harmony import */ var components_Logo_Logo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52175);
// Set of helper functions to facilitate wallet setup



/**
 * Prompt the user to add a custom token to metamask
 * @param tokenAddress
 * @param tokenSymbol
 * @param tokenDecimals
 * @returns {boolean} true if the token has been added, false otherwise
 */ var registerToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(tokenAddress, tokenSymbol, tokenDecimals, tokenLogo) {
        var image, tokenAdded;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    image = tokenLogo ? components_Logo_Logo__WEBPACK_IMPORTED_MODULE_0__/* .BAD_SRCS */ .X[tokenLogo] ? undefined : tokenLogo : undefined;
                    return [
                        4,
                        window.ethereum.request({
                            method: "wallet_watchAsset",
                            params: {
                                type: "ERC20",
                                options: {
                                    address: tokenAddress,
                                    symbol: tokenSymbol,
                                    decimals: tokenDecimals,
                                    image: image
                                }
                            }
                        })
                    ];
                case 1:
                    tokenAdded = _state.sent();
                    return [
                        2,
                        tokenAdded
                    ];
            }
        });
    });
    return function registerToken(tokenAddress, tokenSymbol, tokenDecimals, tokenLogo) {
        return _ref.apply(this, arguments);
    };
}();
var canRegisterToken = function() {
    var ref, ref1, ref2, ref3, ref4;
    return  true && // @ts-ignore
    !(window === null || window === void 0 ? void 0 : (ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isSafePal) && ((window === null || window === void 0 ? void 0 : (ref1 = window.ethereum) === null || ref1 === void 0 ? void 0 : ref1.isMetaMask) || (window === null || window === void 0 ? void 0 : (ref2 = window.ethereum) === null || ref2 === void 0 ? void 0 : ref2.isTrust) || (window === null || window === void 0 ? void 0 : (ref3 = window.ethereum) === null || ref3 === void 0 ? void 0 : ref3.isCoinbaseWallet) || (window === null || window === void 0 ? void 0 : (ref4 = window.ethereum) === null || ref4 === void 0 ? void 0 : ref4.isTokenPocket));
};


/***/ })

}]);